


















































import { Component, Vue } from 'vue-property-decorator';
import Logo from '@/assets/img/Quality2Build.svg';
import displayStore from '@/store/modules/display/displayStore';
import LanguageSelector from './LanguageSelector.vue';
import MobileMenu from '@/components/general/mobileMenu/MobileMenu.vue';
import MobileMenuEntry from '@/components/general/mobileMenu/MobileMenuEntry.vue';
import { RawLocation } from 'vue-router';

interface MenuItem {
  label: string;
  link: RawLocation;
}

@Component({
  components: {
    LanguageSelector,
    Logo,
    MobileMenu,
    MobileMenuEntry,
  },
})
export default class Header extends Vue {
  public isMenuOpen = false;

  public menu: MenuItem[] = [];

  public created(): void {
    this.menu = [
      {
        label: 'general.home',
        link: {
          name: this.Routes.Home,
        },
      },
      {
        label: 'about.about',
        link: {
          name: this.Routes.About,
        },
      },
      {
        label: 'support.support',
        link: {
          name: this.Routes.Support,
        }
      }
    ];
  }

  public async handleMenuClicked(): Promise<void> {
    if (this.isOverlayOpen()) {
      await displayStore.dispatch.closeOverlayMenu();
      return;
    }
    this.isMenuOpen = true;
    await displayStore.dispatch.registerOverlayMenu(() => (this.isMenuOpen = false));
  }

  public isOverlayOpen(): boolean {
    return displayStore.getters.isOverlayOpen();
  }
}
